/** Bind nested template links to the active application without mutating authored configuration. */
export function bindApplicationTemplateDownloads<T>(value: T, applicationId: string): T {
  if (value == null) return value;
  if (Array.isArray(value)) {
    const boundItems = value.map((item) => bindApplicationTemplateDownloads(item, applicationId));
    return boundItems as T;
  }
  if (typeof value !== 'object') return value;

  const record = value as Record<string, unknown>;
  const bound = Object.fromEntries(
    Object.entries(record).map(([key, child]) => [
      key,
      bindApplicationTemplateDownloads(child, applicationId),
    ]),
  );
  const templateKey = record.referenceTemplateKey;
  if (typeof templateKey === 'string' && templateKey.length > 0) {
    bound.downloadUrl =
      '/api/v1/applications/' +
      encodeURIComponent(applicationId) +
      '/reference-templates/' +
      encodeURIComponent(templateKey) +
      '/pdf';
  }
  return bound as T;
}
